// extracted by mini-css-extract-plugin
module.exports = {"departments":"ge-z","departmentHeading":"he-z","departmentSection":"ie-z","departmentName":"je-z","departmentLink":"ke-z","expandIcon":"le-z"};